export type Applink = {
  // Expression which should match the according link uri
  uriExpression: string;
  // The name of the route
  routeName: string;
};

const registry: Applink[] = [];

export function registerAppLinks(links: Applink[]): void {
  for (const link of links) {
    const exists = registry.some(
      (r) => r.uriExpression === link.uriExpression && r.routeName === link.routeName,
    );
    if (!exists) registry.push(link);
  }
}

export function getRegisteredAppLinks(): Applink[] {
  return [...registry];
}
